module.exports = __webpack_public_path__ + "media/images/img-shadow-b0443321b661b1de996621ecb91cc8dd.png";